import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  styleUrls: ['./pagination.component.scss'],
  templateUrl: './pagination.component.html',
  standalone: true,
})
export class AppPaginationComponent {
  @Input() currentPage = 1;
  @Input() showNextPage = false;
  @Output() previousPageEvent = new EventEmitter<MouseEvent>();
  @Output() nextPageEvent = new EventEmitter<MouseEvent>();

  @Input() paginationType: string = 'previousNext';
  @Input() showLoadMore: boolean = true;
  @Output() loadMoreEvent = new EventEmitter<MouseEvent>();

  onPreviousPageEvent(event: MouseEvent) {
    this.previousPageEvent.emit(event);
  }

  onNextPageEvent(event: MouseEvent) {
    this.nextPageEvent.emit(event);
  }

  onLoadMoreEvent(event: MouseEvent) {
    this.loadMoreEvent.emit(event);
  }
}
